import { useTranslation } from 'next-i18next'
import LazyImage from '@components/LazyImage'
import styles from './index.module.sass'

interface Props {
  iconUrl?: string;
}

const ErrorMessage = ({ iconUrl }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={styles.content}>
      <div className={styles.mainImage}>
        <LazyImage
          lazy={0}
          className="responsiveImg"
          src={iconUrl}
        />
      </div>
      <div className={styles.title}>{t('client.liff.title.pagenotfound')}</div>
      <div className={styles.description}>{t('client.liff.desc.pagenotfound')}</div>
    </div>
  )
}

const ICON_404_SVG = '/img/svg/ico-error.svg'
ErrorMessage.defaultProps = {
  iconUrl: ICON_404_SVG
}

export default ErrorMessage
